import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import ApprovalPage from 'tio-common/components/tas/approval/approval-page';
import TioAppearance from 'tio-common/components/tio/appearance';
import Chip from 'tio-ui/components/chip';
import ENV from 'tio-employee/config/environment';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';
import type { ISession } from 'tio-common/types/services';

interface RouteSignature {
  Args: {
    model: TasApplicationModel;
  };
}

export default class TuitionAssistanceApplicationsShowApprovalRoute extends Component<RouteSignature> {
  @service declare session: ISession;

  <template>
    <ApprovalPage @model={{@model}}>
      <:header>
        <div class="tio-row-start-between">
          <div class="tio-col">
            <div class="tio-row-tight">
              <h2 class="tio-text-lg-semibold tio-fg-secondary">
                {{t "tas.approval.application_number"}}
                #{{@model.id}}
              </h2>
              <Chip @appearance="outlined" @intent={{@model.badgeIntent}} @size="sm">
                {{@model.badgeLabel}}
              </Chip>
              {{#if @model.hasWaiverApplied}}
                <Chip @appearance="outlined" @intent="warning" @size="sm">
                  {{t "tas.approval.waiver_applied"}}
                </Chip>
              {{/if}}
              {{#if @model.ignorePolicies}}
                <Chip @appearance="outlined" @intent="danger" @size="sm">
                  {{t "tuition_assistance.application_details.policy_override"}}
                </Chip>
              {{/if}}
              {{#if @model.migrationApplicationId}}
                <Chip @appearance="outlined" @intent="success" @size="sm">
                  {{t "tas.approval.migrated_badge"}}
                </Chip>
              {{/if}}
            </div>
            <div class="tio-row-snug text-sm tio-fg-muted">
              <LinkTo
                @route="authenticated.admin.employees.show"
                @model={{@model.tasProgramInstance.employee.id}}
                class="font-semibold cursor-pointer"
              >
                {{@model.tasProgramInstance.employee.person.fullName}}
              </LinkTo>
              <div class="tio-tas-meta-separator"></div>
              <span class="font-semibold">{{t "tas.approval.payroll_id_label"}}
                {{@model.tasProgramInstance.employee.payrollId}}</span>
            </div>
          </div>
          <div class="tio-stack-end gap-2">
            {{#if @model.id}}
              <LinkTo
                @route="authenticated.admin.tuition-assistance.applications.show"
                @model={{@model.id}}
                class="tio-btn tio-btn--default tio-btn--outlined tio-btn--md"
                data-test-classic-view-button
              >
                {{t "common.tas_approval_queue.view"}}
              </LinkTo>
            {{/if}}
            {{! Who's Viewing }}
            {{#if @model.id}}
              <TioAppearance
                @apiKey={{ENV.apiKey}}
                @apiHost={{ENV.apiHost}}
                @token={{this.session.data.authenticated.access_token}}
                @type="tas_course_application"
                @documentId={{@model.id}}
              />
            {{/if}}
          </div>
        </div>
      </:header>
    </ApprovalPage>
  </template>
}
